import { useAuth0 } from "@auth0/auth0-react"
import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"
import {
  buildPageViewProperties,
  normalizePagePath,
  PAGE_VIEW_EVENT,
} from "instrumentation/tracking/pageViewTracking"
import type { PageViewContext } from "instrumentation/tracking/pageViewTracking"
import { useWoopraAPI } from "instrumentation/tracking/useWoopraApi"

let previousTrackedPath = ""

export function PageViewTracker({
  routePath,
  routeName,
  permissionForPage,
}: PageViewContext) {
  const { isAuthenticated } = useAuth0()
  const location = useLocation()
  const { postTrackingEvent } = useWoopraAPI()
  const lastTrackedNavigationKey = useRef("")

  useEffect(() => {
    if (!isAuthenticated) {
      return
    }

    const path = location.pathname
    const page = normalizePagePath(routePath)
    const navigationKey = `${location.key}:${page}:${path}`

    if (lastTrackedNavigationKey.current === navigationKey) {
      return
    }

    lastTrackedNavigationKey.current = navigationKey

    const properties = buildPageViewProperties({
      path,
      routePath,
      routeName,
      permissionForPage,
      referrerPath: previousTrackedPath,
    })

    previousTrackedPath = path

    void postTrackingEvent({
      page,
      event: PAGE_VIEW_EVENT,
      properties,
    }).catch(() => {
      // Page-view analytics should never block or break routed content.
    })
  }, [
    isAuthenticated,
    location.key,
    location.pathname,
    permissionForPage,
    postTrackingEvent,
    routeName,
    routePath,
  ])

  return null
}
